import { render, staticRenderFns } from "./CellBox.vue?vue&type=template&id=4d5c8ecd"
import script from "./CellBox.vue?vue&type=script&lang=js"
export * from "./CellBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports